import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCooneyBrothers/Handlers/CustomHandlerCreator";

type HandlerType = CustomHandler<{ closeModel: boolean }>;

export const DispatchSetCloseUnhandledModel: HandlerType = props => {
    props.dispatch({
        type: "Custom/Data/SetCloseUnhandledModel",
        closeModel: props.parameter.closeModel,
    });
};

export const chain = [DispatchSetCloseUnhandledModel];

const setCloseUnhandledModel = createHandlerChainRunner(chain, "SetCloseUnhandledModel");
export default setCloseUnhandledModel;
